import * as types from './actionTypes';  
import logoUploadApi from '../api/logoUploadForOfferingApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';

export function logoUpload(data, ext_id) {

  return {
    type: types.UPLOAD_OFFERING_LOGO, 
    data,
    ext_id
  };
}

export function logoUploadRes(data) {  
  return {
    type: types.UPLOAD_OFFERING_LOGO_RES, 
    data
  };
}

export function uploadOfferingLogo(file, ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      logoUploadApi.logoUpload(file, ext_id).then(data => {
        dispatch(logoUploadRes(data));
        dispatch(logoUploadRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
  
}